import { usePostTrackEventWithParams } from "./analyticsQueries"

export type TPurchaseHomeDialogEventTypes = "Purchase Home Dialog Clicked"

function usePostPurchaseHomeDialogTrackingEvent<TEventProperties>(
  event: TPurchaseHomeDialogEventTypes
) {
  return usePostTrackEventWithParams<
    TPurchaseHomeDialogEventTypes,
    TEventProperties
  >({
    event,
  })
}

export function usePostPurchaseHomeDialogClicked() {
  return usePostPurchaseHomeDialogTrackingEvent<{
    selection: "unit_only" | "unit_device"
  }>("Purchase Home Dialog Clicked")
}
